import { createFileRoute, Outlet } from "@tanstack/react-router";

import { VerifyEmailBanner } from "../iam/shared/components/VerifyEmailBanner";

/**
 * Route is /organizations: a bare layout nested under _app so it inherits the auth
 * guard + the app shell. Its URL matches resolveNavSection's IAM prefixes, so the
 * shell sidenav slides to content B here. The index (empty state or redirect) and
 * the per-organization shell each provide their own container; this layout adds only
 * the sticky verify-email header, so it spans every organization page (the index and
 * the per-organization subpages) while the matched child renders through the Outlet.
 */
export const Route = createFileRoute("/_app/organizations")({
  component: OrganizationsLayout,
});

function OrganizationsLayout() {
  return (
    <>
      <VerifyEmailBanner />
      <Outlet />
    </>
  );
}
